import type { ApolloError } from '@apollo/client';
import { useCallback } from 'react';

import { toast } from '@/common/components/shared/toaster/toast';
import { type UpdateNotificationSettingInput, useUpdateNotificationSettingMutation } from '@/common/graphql';
import { ApiUtils } from '@/common/utils';

export const useUpdateNotificationSetting = () => {
  const [updateNotificationSettingMutation, { loading }] = useUpdateNotificationSettingMutation();

  const updateNotificationSetting = useCallback(
    async ({ data }: { data: UpdateNotificationSettingInput }) => {
      await updateNotificationSettingMutation({
        variables: {
          input: data,
        },
        onCompleted: () => toast.success(),
        onError: (error: ApolloError) => ApiUtils.handleApiError(error),
      });
    },
    [updateNotificationSettingMutation],
  );

  return { updateNotificationSetting, saving: loading };
};
